import React from 'react';

interface FilterCheckboxProps {
  label: string;
  count?: number;
  checked: boolean;
  onChange: (checked: boolean) => void;
}

export function FilterCheckbox({
  label,
  count,
  checked,
  onChange,
}: FilterCheckboxProps) {
  if (typeof onChange !== 'function') {
    throw new Error('FilterCheckbox: onChange prop must be a function');
  }

  return (
    <label className="flex cursor-pointer items-center gap-2 py-1 hover:bg-gray-50">
      <input
        type="checkbox"
        checked={checked}
        onChange={e => {
          onChange(e.target.checked);
        }}
        className="text-primary-600 focus:ring-primary-500 accent-primary-600 h-4 w-4 rounded border-gray-300"
      />
      <span className="text-sm text-gray-900">
        {label}
        {count !== undefined && (
          <span className="ml-1 text-gray-500">({count})</span>
        )}
      </span>
    </label>
  );
}
